import classNames from 'classnames';
import { forwardRef, InputHTMLAttributes } from 'react';

import IconError from '../../icons/error.svg';
import styles from '../form-fields.module.css';

type Props = InputHTMLAttributes<HTMLInputElement> & {
    label: string
    className?: string
    error?: string
};

export const Input = forwardRef<HTMLInputElement, Props>(({ label, error, className = '', ...props }, ref) => (
    <div>
        <label className={styles['form-field__label']}>
            <input
                ref={ref}
                className={classNames(styles['form-field__field'], {
                    [styles['form-field__field--has-error']]: !!error
                }, className)}
                placeholder={label}
                {...props} />
            <span>{label}</span>
        </label>

        {!!error && (
            <p className={styles['form-field__error']}>
                <IconError className={styles['form-field__error-icon']} />
                {error}
            </p>
        )}
    </div>
));
